/**
 * Generated by "@vuepress/internal-routes"
 */

import { injectComponentOption, ensureAsyncComponentsLoaded } from '@app/util'
import rootMixins from '@internal/root-mixins'
import GlobalLayout from "/Users/fengjianxin/workspaces/blog/blog.fengjx.com/node_modules/.pnpm/@vuepress+core@1.9.10_@vue+compiler-sfc@3.4.23_ejs@2.7.4_hogan.js@3.0.2_lodash@4.17.21_underscore@1.13.6/node_modules/@vuepress/core/lib/client/components/GlobalLayout.vue"

injectComponentOption(GlobalLayout, 'mixins', rootMixins)
export const routes = [
  {
    name: "v-4ad37bea",
    path: "/go/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-4ad37bea").then(next)
    },
  },
  {
    path: "/go/index.html",
    redirect: "/go/"
  },
  {
    path: "/02.go/01.README.html",
    redirect: "/go/"
  },
  {
    name: "v-5b74fcf9",
    path: "/awesome/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-5b74fcf9").then(next)
    },
  },
  {
    path: "/awesome/index.html",
    redirect: "/awesome/"
  },
  {
    path: "/01.收藏/01.awesome.html",
    redirect: "/awesome/"
  },
  {
    name: "v-9728a4ea",
    path: "/pages/40737e/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9728a4ea").then(next)
    },
  },
  {
    path: "/pages/40737e/index.html",
    redirect: "/pages/40737e/"
  },
  {
    path: "/02.go/10.go-kit/01.quickstart.html",
    redirect: "/pages/40737e/"
  },
  {
    name: "v-b0c73eea",
    path: "/pages/efb886/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-b0c73eea").then(next)
    },
  },
  {
    path: "/pages/efb886/index.html",
    redirect: "/pages/efb886/"
  },
  {
    path: "/02.go/10.go-kit/02.protocol-support.html",
    redirect: "/pages/efb886/"
  },
  {
    name: "v-dd5133aa",
    path: "/pages/d6f092/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-dd5133aa").then(next)
    },
  },
  {
    path: "/pages/d6f092/index.html",
    redirect: "/pages/d6f092/"
  },
  {
    path: "/02.go/10.go-kit/03.middleware.html",
    redirect: "/pages/d6f092/"
  },
  {
    name: "v-6a920f57",
    path: "/pages/a15528/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-6a920f57").then(next)
    },
  },
  {
    path: "/pages/a15528/index.html",
    redirect: "/pages/a15528/"
  },
  {
    path: "/02.go/10.go-kit/04.discovery.html",
    redirect: "/pages/a15528/"
  },
  {
    name: "v-5783042a",
    path: "/java/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-5783042a").then(next)
    },
  },
  {
    path: "/java/index.html",
    redirect: "/java/"
  },
  {
    path: "/03.java/01.README.html",
    redirect: "/java/"
  },
  {
    name: "v-59ec457e",
    path: "/pages/581190/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-59ec457e").then(next)
    },
  },
  {
    path: "/pages/581190/index.html",
    redirect: "/pages/581190/"
  },
  {
    path: "/03.java/10.版本特性/01.java8/01.lambda-function.html",
    redirect: "/pages/581190/"
  },
  {
    name: "v-b91e7d08",
    path: "/pages/8a3a67/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-b91e7d08").then(next)
    },
  },
  {
    path: "/pages/8a3a67/index.html",
    redirect: "/pages/8a3a67/"
  },
  {
    path: "/03.java/10.版本特性/01.java8/02.date.html",
    redirect: "/pages/8a3a67/"
  },
  {
    name: "v-6e39319c",
    path: "/pages/1a3449/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-6e39319c").then(next)
    },
  },
  {
    path: "/pages/1a3449/index.html",
    redirect: "/pages/1a3449/"
  },
  {
    path: "/03.java/10.版本特性/01.java8/04.stream.html",
    redirect: "/pages/1a3449/"
  },
  {
    name: "v-9b01d8c4",
    path: "/pages/191279/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9b01d8c4").then(next)
    },
  },
  {
    path: "/pages/191279/index.html",
    redirect: "/pages/191279/"
  },
  {
    path: "/03.java/10.版本特性/01.java8/05.optional.html",
    redirect: "/pages/191279/"
  },
  {
    name: "v-40aa688b",
    path: "/pages/fc50f5/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-40aa688b").then(next)
    },
  },
  {
    path: "/pages/fc50f5/index.html",
    redirect: "/pages/fc50f5/"
  },
  {
    path: "/03.java/20.jvm/01.jvm.html",
    redirect: "/pages/fc50f5/"
  },
  {
    name: "v-7cfced2a",
    path: "/pages/9e1ec7/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-7cfced2a").then(next)
    },
  },
  {
    path: "/pages/9e1ec7/index.html",
    redirect: "/pages/9e1ec7/"
  },
  {
    path: "/03.java/20.jvm/02.jvm-runtime-data-area.html",
    redirect: "/pages/9e1ec7/"
  },
  {
    name: "v-479feea1",
    path: "/pages/57792d/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-479feea1").then(next)
    },
  },
  {
    path: "/pages/57792d/index.html",
    redirect: "/pages/57792d/"
  },
  {
    path: "/03.java/20.jvm/03.gc.html",
    redirect: "/pages/57792d/"
  },
  {
    name: "v-68d0614e",
    path: "/pages/eeb95f/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-68d0614e").then(next)
    },
  },
  {
    path: "/pages/eeb95f/index.html",
    redirect: "/pages/eeb95f/"
  },
  {
    path: "/03.java/20.jvm/04.jvm-option.html",
    redirect: "/pages/eeb95f/"
  },
  {
    name: "v-3885166a",
    path: "/pages/d0ff21/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-3885166a").then(next)
    },
  },
  {
    path: "/pages/d0ff21/index.html",
    redirect: "/pages/d0ff21/"
  },
  {
    path: "/03.java/20.jvm/05.tools.html",
    redirect: "/pages/d0ff21/"
  },
  {
    name: "v-129e79de",
    path: "/pages/2204ba/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-129e79de").then(next)
    },
  },
  {
    path: "/pages/2204ba/index.html",
    redirect: "/pages/2204ba/"
  },
  {
    path: "/03.java/20.jvm/07.class-loader.html",
    redirect: "/pages/2204ba/"
  },
  {
    name: "v-2ddbe08c",
    path: "/pages/94fd66/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-2ddbe08c").then(next)
    },
  },
  {
    path: "/pages/94fd66/index.html",
    redirect: "/pages/94fd66/"
  },
  {
    path: "/03.java/10.版本特性/01.java8/03.method-ref.html",
    redirect: "/pages/94fd66/"
  },
  {
    name: "v-d5bb5e54",
    path: "/pages/32a147/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-d5bb5e54").then(next)
    },
  },
  {
    path: "/pages/32a147/index.html",
    redirect: "/pages/32a147/"
  },
  {
    path: "/03.java/30.网络编程/02.netty.html",
    redirect: "/pages/32a147/"
  },
  {
    name: "v-153b23a3",
    path: "/pages/669a06/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-153b23a3").then(next)
    },
  },
  {
    path: "/pages/669a06/index.html",
    redirect: "/pages/669a06/"
  },
  {
    path: "/03.java/40.并发编程/01.index.html",
    redirect: "/pages/669a06/"
  },
  {
    name: "v-6d2822ea",
    path: "/pages/0b1de7/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-6d2822ea").then(next)
    },
  },
  {
    path: "/pages/0b1de7/index.html",
    redirect: "/pages/0b1de7/"
  },
  {
    path: "/03.java/40.并发编程/02.thread-Introduction.html",
    redirect: "/pages/0b1de7/"
  },
  {
    name: "v-bf65436a",
    path: "/pages/86ec0a/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-bf65436a").then(next)
    },
  },
  {
    path: "/pages/86ec0a/index.html",
    redirect: "/pages/86ec0a/"
  },
  {
    path: "/03.java/20.jvm/100.hot-reload.html",
    redirect: "/pages/86ec0a/"
  },
  {
    name: "v-61b67179",
    path: "/pages/4f57d7/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-61b67179").then(next)
    },
  },
  {
    path: "/pages/4f57d7/index.html",
    redirect: "/pages/4f57d7/"
  },
  {
    path: "/03.java/40.并发编程/03.thread-stop.html",
    redirect: "/pages/4f57d7/"
  },
  {
    name: "v-498e570c",
    path: "/pages/129a86/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-498e570c").then(next)
    },
  },
  {
    path: "/pages/129a86/index.html",
    redirect: "/pages/129a86/"
  },
  {
    path: "/03.java/30.网络编程/01.java-io.html",
    redirect: "/pages/129a86/"
  },
  {
    name: "v-1af8d1d7",
    path: "/pages/78bf2e/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1af8d1d7").then(next)
    },
  },
  {
    path: "/pages/78bf2e/index.html",
    redirect: "/pages/78bf2e/"
  },
  {
    path: "/03.java/40.并发编程/04.thread-awesome.html",
    redirect: "/pages/78bf2e/"
  },
  {
    name: "v-1e490957",
    path: "/pages/335338/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1e490957").then(next)
    },
  },
  {
    path: "/pages/335338/index.html",
    redirect: "/pages/335338/"
  },
  {
    path: "/03.java/40.并发编程/05.thread-pool-size.html",
    redirect: "/pages/335338/"
  },
  {
    name: "v-7ad6f0c3",
    path: "/pages/5f2440/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-7ad6f0c3").then(next)
    },
  },
  {
    path: "/pages/5f2440/index.html",
    redirect: "/pages/5f2440/"
  },
  {
    path: "/03.java/40.并发编程/04.thread-pool.html",
    redirect: "/pages/5f2440/"
  },
  {
    name: "v-372e54ca",
    path: "/pages/2c5d93/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-372e54ca").then(next)
    },
  },
  {
    path: "/pages/2c5d93/index.html",
    redirect: "/pages/2c5d93/"
  },
  {
    path: "/03.java/40.并发编程/06.queue.html",
    redirect: "/pages/2c5d93/"
  },
  {
    name: "v-12eaebf6",
    path: "/pages/b4b97e/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-12eaebf6").then(next)
    },
  },
  {
    path: "/pages/b4b97e/index.html",
    redirect: "/pages/b4b97e/"
  },
  {
    path: "/03.java/40.并发编程/07.limit.html",
    redirect: "/pages/b4b97e/"
  },
  {
    name: "v-54bb0520",
    path: "/architect/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-54bb0520").then(next)
    },
  },
  {
    path: "/architect/index.html",
    redirect: "/architect/"
  },
  {
    path: "/08.架构/01.概览/01.README.html",
    redirect: "/architect/"
  },
  {
    name: "v-77d02922",
    path: "/pages/11981c/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-77d02922").then(next)
    },
  },
  {
    path: "/pages/11981c/index.html",
    redirect: "/pages/11981c/"
  },
  {
    path: "/08.架构/05.设计模式/01.README.html",
    redirect: "/pages/11981c/"
  },
  {
    name: "v-1e3873d3",
    path: "/pages/0c5862/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1e3873d3").then(next)
    },
  },
  {
    path: "/pages/0c5862/index.html",
    redirect: "/pages/0c5862/"
  },
  {
    path: "/08.架构/05.设计模式/02.创建型/10.singleton.html",
    redirect: "/pages/0c5862/"
  },
  {
    name: "v-194d30e6",
    path: "/pages/d36eab/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-194d30e6").then(next)
    },
  },
  {
    path: "/pages/d36eab/index.html",
    redirect: "/pages/d36eab/"
  },
  {
    path: "/08.架构/05.设计模式/03.结构型/12.decorator.html",
    redirect: "/pages/d36eab/"
  },
  {
    name: "v-e6faa118",
    path: "/pages/4c6784/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-e6faa118").then(next)
    },
  },
  {
    path: "/pages/4c6784/index.html",
    redirect: "/pages/4c6784/"
  },
  {
    path: "/08.架构/05.设计模式/03.结构型/13.delegation.html",
    redirect: "/pages/4c6784/"
  },
  {
    name: "v-74f8eec6",
    path: "/pages/5a8d03/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-74f8eec6").then(next)
    },
  },
  {
    path: "/pages/5a8d03/index.html",
    redirect: "/pages/5a8d03/"
  },
  {
    path: "/08.架构/05.设计模式/03.结构型/14.proxy.html",
    redirect: "/pages/5a8d03/"
  },
  {
    name: "v-30b54400",
    path: "/pages/782922/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-30b54400").then(next)
    },
  },
  {
    path: "/pages/782922/index.html",
    redirect: "/pages/782922/"
  },
  {
    path: "/08.架构/05.设计模式/04.行为型/20.observer.html",
    redirect: "/pages/782922/"
  },
  {
    name: "v-2813a68c",
    path: "/pages/341eba/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-2813a68c").then(next)
    },
  },
  {
    path: "/pages/341eba/index.html",
    redirect: "/pages/341eba/"
  },
  {
    path: "/08.架构/05.设计模式/04.行为型/21.template.html",
    redirect: "/pages/341eba/"
  },
  {
    name: "v-a41f82ec",
    path: "/pages/1ddae1/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-a41f82ec").then(next)
    },
  },
  {
    path: "/pages/1ddae1/index.html",
    redirect: "/pages/1ddae1/"
  },
  {
    path: "/08.架构/05.设计模式/04.行为型/22.strategy.html",
    redirect: "/pages/1ddae1/"
  },
  {
    name: "v-ead089b2",
    path: "/pages/2ea024/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-ead089b2").then(next)
    },
  },
  {
    path: "/pages/2ea024/index.html",
    redirect: "/pages/2ea024/"
  },
  {
    path: "/08.架构/100.云原生/01.k8s-install.html",
    redirect: "/pages/2ea024/"
  },
  {
    name: "v-72d3ef13",
    path: "/pages/963fa5/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-72d3ef13").then(next)
    },
  },
  {
    path: "/pages/963fa5/index.html",
    redirect: "/pages/963fa5/"
  },
  {
    path: "/08.架构/05.设计模式/02.创建型/11.factory.html",
    redirect: "/pages/963fa5/"
  },
  {
    name: "v-d4350b52",
    path: "/pages/4d24b0/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-d4350b52").then(next)
    },
  },
  {
    path: "/pages/4d24b0/index.html",
    redirect: "/pages/4d24b0/"
  },
  {
    path: "/08.架构/100.云原生/02.k8s-dashboard-install.html",
    redirect: "/pages/4d24b0/"
  },
  {
    name: "v-71bdf13e",
    path: "/wrk/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-71bdf13e").then(next)
    },
  },
  {
    path: "/wrk/index.html",
    redirect: "/wrk/"
  },
  {
    path: "/08.架构/20.性能优化/00.性能测试工具/01.wrk.html",
    redirect: "/wrk/"
  },
  {
    name: "v-5f40d645",
    path: "/pages/419c0e/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-5f40d645").then(next)
    },
  },
  {
    path: "/pages/419c0e/index.html",
    redirect: "/pages/419c0e/"
  },
  {
    path: "/08.架构/20.性能优化/01.tomcat-performance.html",
    redirect: "/pages/419c0e/"
  },
  {
    name: "v-d07de08c",
    path: "/pages/c998ad/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-d07de08c").then(next)
    },
  },
  {
    path: "/pages/c998ad/index.html",
    redirect: "/pages/c998ad/"
  },
  {
    path: "/08.架构/30.分布式/04.zookeeper/01.README.html",
    redirect: "/pages/c998ad/"
  },
  {
    name: "v-4ddd309a",
    path: "/pages/d77b23/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-4ddd309a").then(next)
    },
  },
  {
    path: "/pages/d77b23/index.html",
    redirect: "/pages/d77b23/"
  },
  {
    path: "/08.架构/30.分布式/04.zookeeper/02.case.html",
    redirect: "/pages/d77b23/"
  },
  {
    name: "v-15fa46f7",
    path: "/openresty/gateway/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-15fa46f7").then(next)
    },
  },
  {
    path: "/openresty/gateway/index.html",
    redirect: "/openresty/gateway/"
  },
  {
    path: "/08.架构/40.网关/01.openresty/01.gateway.html",
    redirect: "/openresty/gateway/"
  },
  {
    name: "v-5e62bf4b",
    path: "/pages/5bffac/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-5e62bf4b").then(next)
    },
  },
  {
    path: "/pages/5bffac/index.html",
    redirect: "/pages/5bffac/"
  },
  {
    path: "/08.架构/40.网关/01.openresty/02.test-nginx.html",
    redirect: "/pages/5bffac/"
  },
  {
    name: "v-4d30d458",
    path: "/sentinel-dashboard-apollo/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-4d30d458").then(next)
    },
  },
  {
    path: "/sentinel-dashboard-apollo/index.html",
    redirect: "/sentinel-dashboard-apollo/"
  },
  {
    path: "/08.架构/50.流量治理/01.sentinel-dashboard-apollo.html",
    redirect: "/sentinel-dashboard-apollo/"
  },
  {
    name: "v-7d13fff4",
    path: "/sentinel-dashboard-apollo-wiki/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-7d13fff4").then(next)
    },
  },
  {
    path: "/sentinel-dashboard-apollo-wiki/index.html",
    redirect: "/sentinel-dashboard-apollo-wiki/"
  },
  {
    path: "/08.架构/50.流量治理/02.sentinel-dashboard-apollo-wiki.html",
    redirect: "/sentinel-dashboard-apollo-wiki/"
  },
  {
    name: "v-625a59c6",
    path: "/pages/62b861/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-625a59c6").then(next)
    },
  },
  {
    path: "/pages/62b861/index.html",
    redirect: "/pages/62b861/"
  },
  {
    path: "/08.架构/60.数据治理/05.mysql数据同步方案-canal高可用部署.html",
    redirect: "/pages/62b861/"
  },
  {
    name: "v-72ef2f8f",
    path: "/book/java/alibaba-java-manual/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-72ef2f8f").then(next)
    },
  },
  {
    path: "/book/java/alibaba-java-manual/index.html",
    redirect: "/book/java/alibaba-java-manual/"
  },
  {
    path: "/09.book/01.java/01.alibaba-java-manual.html",
    redirect: "/book/java/alibaba-java-manual/"
  },
  {
    name: "v-716d7f2b",
    path: "/book/java/effective-java-3/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-716d7f2b").then(next)
    },
  },
  {
    path: "/book/java/effective-java-3/index.html",
    redirect: "/book/java/effective-java-3/"
  },
  {
    path: "/09.book/01.java/02.effective-java-3.html",
    redirect: "/book/java/effective-java-3/"
  },
  {
    name: "v-6389cc8b",
    path: "/book/java/refactor/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-6389cc8b").then(next)
    },
  },
  {
    path: "/book/java/refactor/index.html",
    redirect: "/book/java/refactor/"
  },
  {
    path: "/09.book/01.java/03.refactor.html",
    redirect: "/book/java/refactor/"
  },
  {
    name: "v-19aaeeeb",
    path: "/book/java/google-guava/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-19aaeeeb").then(next)
    },
  },
  {
    path: "/book/java/google-guava/index.html",
    redirect: "/book/java/google-guava/"
  },
  {
    path: "/09.book/01.java/04.google-guava.html",
    redirect: "/book/java/google-guava/"
  },
  {
    name: "v-9a8449ac",
    path: "/book/java/inside-in-jvm/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9a8449ac").then(next)
    },
  },
  {
    path: "/book/java/inside-in-jvm/index.html",
    redirect: "/book/java/inside-in-jvm/"
  },
  {
    path: "/09.book/01.java/05.inside in-jvm.html",
    redirect: "/book/java/inside-in-jvm/"
  },
  {
    name: "v-41dd9e6b",
    path: "/book/nginx/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-41dd9e6b").then(next)
    },
  },
  {
    path: "/book/nginx/index.html",
    redirect: "/book/nginx/"
  },
  {
    path: "/09.book/02.nginx/01.nginx.html",
    redirect: "/book/nginx/"
  },
  {
    name: "v-4642faab",
    path: "/book/nginx/openresty/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-4642faab").then(next)
    },
  },
  {
    path: "/book/nginx/openresty/index.html",
    redirect: "/book/nginx/openresty/"
  },
  {
    path: "/09.book/02.nginx/02.openresty.html",
    redirect: "/book/nginx/openresty/"
  },
  {
    name: "v-b4f3a32a",
    path: "/book/nginx/agentzh-nginx/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-b4f3a32a").then(next)
    },
  },
  {
    path: "/book/nginx/agentzh-nginx/index.html",
    redirect: "/book/nginx/agentzh-nginx/"
  },
  {
    path: "/09.book/02.nginx/03.agentzh-nginx.html",
    redirect: "/book/nginx/agentzh-nginx/"
  },
  {
    name: "v-2c3605cb",
    path: "/book/security/web-hacking-tech-revealed/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-2c3605cb").then(next)
    },
  },
  {
    path: "/book/security/web-hacking-tech-revealed/index.html",
    redirect: "/book/security/web-hacking-tech-revealed/"
  },
  {
    path: "/09.book/03.security/01.web-hacking-tech-revealed.html",
    redirect: "/book/security/web-hacking-tech-revealed/"
  },
  {
    name: "v-8caa486a",
    path: "/book/sre/linux-cmd/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-8caa486a").then(next)
    },
  },
  {
    path: "/book/sre/linux-cmd/index.html",
    redirect: "/book/sre/linux-cmd/"
  },
  {
    path: "/09.book/04.sre/01.linux-cmd.html",
    redirect: "/book/sre/linux-cmd/"
  },
  {
    name: "v-1ca90dcb",
    path: "/book/security/white-hat-web-security/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1ca90dcb").then(next)
    },
  },
  {
    path: "/book/security/white-hat-web-security/index.html",
    redirect: "/book/security/white-hat-web-security/"
  },
  {
    path: "/09.book/03.security/02.white-hat-web-security.html",
    redirect: "/book/security/white-hat-web-security/"
  },
  {
    name: "v-9ed1f22a",
    path: "/book/sre/shellbook/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9ed1f22a").then(next)
    },
  },
  {
    path: "/book/sre/shellbook/index.html",
    redirect: "/book/sre/shellbook/"
  },
  {
    path: "/09.book/04.sre/02.shellbook.html",
    redirect: "/book/sre/shellbook/"
  },
  {
    name: "v-0ad53ceb",
    path: "/book/sre/vbird-linux-basic-4/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-0ad53ceb").then(next)
    },
  },
  {
    path: "/book/sre/vbird-linux-basic-4/index.html",
    redirect: "/book/sre/vbird-linux-basic-4/"
  },
  {
    path: "/09.book/04.sre/03.vbird-linux-basic-4.html",
    redirect: "/book/sre/vbird-linux-basic-4/"
  },
  {
    name: "v-29cf8700",
    path: "/pages/8f6be4/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-29cf8700").then(next)
    },
  },
  {
    path: "/pages/8f6be4/index.html",
    redirect: "/pages/8f6be4/"
  },
  {
    path: "/10.数据库/01.mysql/01.InnoDB.html",
    redirect: "/pages/8f6be4/"
  },
  {
    name: "v-e9915c6c",
    path: "/pages/fc05b5/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-e9915c6c").then(next)
    },
  },
  {
    path: "/pages/fc05b5/index.html",
    redirect: "/pages/fc05b5/"
  },
  {
    path: "/10.数据库/01.mysql/02.mysql-index.html",
    redirect: "/pages/fc05b5/"
  },
  {
    name: "v-f2ef1a4c",
    path: "/pages/e4f078/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-f2ef1a4c").then(next)
    },
  },
  {
    path: "/pages/e4f078/index.html",
    redirect: "/pages/e4f078/"
  },
  {
    path: "/10.数据库/01.mysql/03.transaction.html",
    redirect: "/pages/e4f078/"
  },
  {
    name: "v-b8b6d6e8",
    path: "/pages/0e45e4/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-b8b6d6e8").then(next)
    },
  },
  {
    path: "/pages/0e45e4/index.html",
    redirect: "/pages/0e45e4/"
  },
  {
    path: "/10.数据库/01.mysql/04.log.html",
    redirect: "/pages/0e45e4/"
  },
  {
    name: "v-416ada00",
    path: "/pages/9239fb/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-416ada00").then(next)
    },
  },
  {
    path: "/pages/9239fb/index.html",
    redirect: "/pages/9239fb/"
  },
  {
    path: "/10.数据库/01.mysql/05.order-by.html",
    redirect: "/pages/9239fb/"
  },
  {
    name: "v-606b70a0",
    path: "/pages/3ce3c6/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-606b70a0").then(next)
    },
  },
  {
    path: "/pages/3ce3c6/index.html",
    redirect: "/pages/3ce3c6/"
  },
  {
    path: "/10.数据库/01.mysql/06.performance.html",
    redirect: "/pages/3ce3c6/"
  },
  {
    name: "v-81d08974",
    path: "/pages/58ee1f/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-81d08974").then(next)
    },
  },
  {
    path: "/pages/58ee1f/index.html",
    redirect: "/pages/58ee1f/"
  },
  {
    path: "/10.数据库/01.mysql/08.specification.html",
    redirect: "/pages/58ee1f/"
  },
  {
    name: "v-24b4a7ce",
    path: "/pages/744ea9/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-24b4a7ce").then(next)
    },
  },
  {
    path: "/pages/744ea9/index.html",
    redirect: "/pages/744ea9/"
  },
  {
    path: "/10.数据库/01.mysql/09.options.html",
    redirect: "/pages/744ea9/"
  },
  {
    name: "v-9e58f22c",
    path: "/pages/1af172/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-9e58f22c").then(next)
    },
  },
  {
    path: "/pages/1af172/index.html",
    redirect: "/pages/1af172/"
  },
  {
    path: "/10.数据库/01.mysql/10.cmd.html",
    redirect: "/pages/1af172/"
  },
  {
    name: "v-3473d938",
    path: "/pages/9ecfb4/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-3473d938").then(next)
    },
  },
  {
    path: "/pages/9ecfb4/index.html",
    redirect: "/pages/9ecfb4/"
  },
  {
    path: "/10.数据库/01.mysql/20.mycli.html",
    redirect: "/pages/9ecfb4/"
  },
  {
    name: "v-cedceca4",
    path: "/pages/b30316/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-cedceca4").then(next)
    },
  },
  {
    path: "/pages/b30316/index.html",
    redirect: "/pages/b30316/"
  },
  {
    path: "/10.数据库/02.redis/00.redis-kv-rehash.html",
    redirect: "/pages/b30316/"
  },
  {
    name: "v-77cadee8",
    path: "/pages/7d45f8/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-77cadee8").then(next)
    },
  },
  {
    path: "/pages/7d45f8/index.html",
    redirect: "/pages/7d45f8/"
  },
  {
    path: "/10.数据库/02.redis/01.redis-structure.html",
    redirect: "/pages/7d45f8/"
  },
  {
    name: "v-26decd72",
    path: "/pages/81a37c/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-26decd72").then(next)
    },
  },
  {
    path: "/pages/81a37c/index.html",
    redirect: "/pages/81a37c/"
  },
  {
    path: "/10.数据库/02.redis/02.redis-persistence.html",
    redirect: "/pages/81a37c/"
  },
  {
    name: "v-63c01e10",
    path: "/pages/95c88a/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-63c01e10").then(next)
    },
  },
  {
    path: "/pages/95c88a/index.html",
    redirect: "/pages/95c88a/"
  },
  {
    path: "/100.其他/01.linux/01.bash.html",
    redirect: "/pages/95c88a/"
  },
  {
    name: "v-1bbe32f0",
    path: "/pages/019efa/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1bbe32f0").then(next)
    },
  },
  {
    path: "/pages/019efa/index.html",
    redirect: "/pages/019efa/"
  },
  {
    path: "/100.其他/02.tools/01.idea.html",
    redirect: "/pages/019efa/"
  },
  {
    name: "v-018ef36b",
    path: "/alg/lru-cache/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-018ef36b").then(next)
    },
  },
  {
    path: "/alg/lru-cache/index.html",
    redirect: "/alg/lru-cache/"
  },
  {
    path: "/20.alg/02.lru-cache.html",
    redirect: "/alg/lru-cache/"
  },
  {
    name: "v-b3a5899a",
    path: "/about/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-b3a5899a").then(next)
    },
  },
  {
    path: "/about/index.html",
    redirect: "/about/"
  },
  {
    path: "/50.关于/01.about.html",
    redirect: "/about/"
  },
  {
    name: "v-74958907",
    path: "/links/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-74958907").then(next)
    },
  },
  {
    path: "/links/index.html",
    redirect: "/links/"
  },
  {
    path: "/51.链接/01.links.html",
    redirect: "/links/"
  },
  {
    name: "v-2701192e",
    path: "/pages/0bdae1/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-2701192e").then(next)
    },
  },
  {
    path: "/pages/0bdae1/index.html",
    redirect: "/pages/0bdae1/"
  },
  {
    path: "/_posts/参考文档/chrome-download.html",
    redirect: "/pages/0bdae1/"
  },
  {
    name: "v-67169a4a",
    path: "/pages/e1e29a/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-67169a4a").then(next)
    },
  },
  {
    path: "/pages/e1e29a/index.html",
    redirect: "/pages/e1e29a/"
  },
  {
    path: "/_posts/参考文档/ffmpeg-merge-video.html",
    redirect: "/pages/e1e29a/"
  },
  {
    name: "v-f4124298",
    path: "/pages/6ff370/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-f4124298").then(next)
    },
  },
  {
    path: "/pages/6ff370/index.html",
    redirect: "/pages/6ff370/"
  },
  {
    path: "/_posts/参考文档/git-flow.html",
    redirect: "/pages/6ff370/"
  },
  {
    name: "v-e8fb1fe4",
    path: "/pages/7edbe3/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-e8fb1fe4").then(next)
    },
  },
  {
    path: "/pages/7edbe3/index.html",
    redirect: "/pages/7edbe3/"
  },
  {
    path: "/_posts/参考文档/git.html",
    redirect: "/pages/7edbe3/"
  },
  {
    name: "v-69cf1cce",
    path: "/pages/f94a96/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-69cf1cce").then(next)
    },
  },
  {
    path: "/pages/f94a96/index.html",
    redirect: "/pages/f94a96/"
  },
  {
    path: "/_posts/参考文档/github-pr.html",
    redirect: "/pages/f94a96/"
  },
  {
    name: "v-45aeae6e",
    path: "/pages/1d70fc/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-45aeae6e").then(next)
    },
  },
  {
    path: "/pages/1d70fc/index.html",
    redirect: "/pages/1d70fc/"
  },
  {
    path: "/_posts/参考文档/idea-2020.1-crash.html",
    redirect: "/pages/1d70fc/"
  },
  {
    name: "v-3f299912",
    path: "/pages/8cb7a9/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-3f299912").then(next)
    },
  },
  {
    path: "/pages/8cb7a9/index.html",
    redirect: "/pages/8cb7a9/"
  },
  {
    path: "/_posts/参考文档/mac-app-tools-list.html",
    redirect: "/pages/8cb7a9/"
  },
  {
    name: "v-7c8c7950",
    path: "/pages/a1d738/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-7c8c7950").then(next)
    },
  },
  {
    path: "/pages/a1d738/index.html",
    redirect: "/pages/a1d738/"
  },
  {
    path: "/_posts/参考文档/mac-keymap.html",
    redirect: "/pages/a1d738/"
  },
  {
    name: "v-e529898c",
    path: "/pages/4174de/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-e529898c").then(next)
    },
  },
  {
    path: "/pages/4174de/index.html",
    redirect: "/pages/4174de/"
  },
  {
    path: "/_posts/参考文档/mac-supervisor.html",
    redirect: "/pages/4174de/"
  },
  {
    name: "v-6a0b9224",
    path: "/pages/19a763/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-6a0b9224").then(next)
    },
  },
  {
    path: "/pages/19a763/index.html",
    redirect: "/pages/19a763/"
  },
  {
    path: "/_posts/参考文档/manjaro-install-docker.html",
    redirect: "/pages/19a763/"
  },
  {
    name: "v-0e7a7aae",
    path: "/pages/ddd66b/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-0e7a7aae").then(next)
    },
  },
  {
    path: "/pages/ddd66b/index.html",
    redirect: "/pages/ddd66b/"
  },
  {
    path: "/_posts/参考文档/manjaro-install-mysql.html",
    redirect: "/pages/ddd66b/"
  },
  {
    name: "v-05b7089c",
    path: "/pages/64b9b4/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-05b7089c").then(next)
    },
  },
  {
    path: "/pages/64b9b4/index.html",
    redirect: "/pages/64b9b4/"
  },
  {
    path: "/_posts/参考文档/node-cli.html",
    redirect: "/pages/64b9b4/"
  },
  {
    name: "v-225ee0ba",
    path: "/pages/25e556/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-225ee0ba").then(next)
    },
  },
  {
    path: "/pages/25e556/index.html",
    redirect: "/pages/25e556/"
  },
  {
    path: "/_posts/参考文档/npm-yarn.html",
    redirect: "/pages/25e556/"
  },
  {
    name: "v-70572fee",
    path: "/pages/feb83a/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-70572fee").then(next)
    },
  },
  {
    path: "/pages/feb83a/index.html",
    redirect: "/pages/feb83a/"
  },
  {
    path: "/_posts/参考文档/shell-command-not-found.html",
    redirect: "/pages/feb83a/"
  },
  {
    name: "v-1fb0c664",
    path: "/pages/87e2c8/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-1fb0c664").then(next)
    },
  },
  {
    path: "/pages/87e2c8/index.html",
    redirect: "/pages/87e2c8/"
  },
  {
    path: "/_posts/参考文档/ubuntu-rinetd.html",
    redirect: "/pages/87e2c8/"
  },
  {
    name: "v-207c3900",
    path: "/pages/fdfa98/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-207c3900").then(next)
    },
  },
  {
    path: "/pages/fdfa98/index.html",
    redirect: "/pages/fdfa98/"
  },
  {
    path: "/_posts/参考文档/ubuntu-uninstall-libreoffice.html",
    redirect: "/pages/fdfa98/"
  },
  {
    name: "v-76c45419",
    path: "/pages/f3a809/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-76c45419").then(next)
    },
  },
  {
    path: "/pages/f3a809/index.html",
    redirect: "/pages/f3a809/"
  },
  {
    path: "/_posts/随笔/How-To-Ask-Questions-The-Smart-Way.html",
    redirect: "/pages/f3a809/"
  },
  {
    name: "v-c5a5552a",
    path: "/archives/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-c5a5552a").then(next)
    },
  },
  {
    path: "/archives/index.html",
    redirect: "/archives/"
  },
  {
    path: "/@pages/archivesPage.html",
    redirect: "/archives/"
  },
  {
    name: "v-5eddedcb",
    path: "/categories/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-5eddedcb").then(next)
    },
  },
  {
    path: "/categories/index.html",
    redirect: "/categories/"
  },
  {
    path: "/@pages/categoriesPage.html",
    redirect: "/categories/"
  },
  {
    name: "v-14d3fe2a",
    path: "/tags/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-14d3fe2a").then(next)
    },
  },
  {
    path: "/tags/index.html",
    redirect: "/tags/"
  },
  {
    path: "/@pages/tagsPage.html",
    redirect: "/tags/"
  },
  {
    name: "v-3e486ff8",
    path: "/",
    component: GlobalLayout,
    beforeEnter: (to, from, next) => {
      ensureAsyncComponentsLoaded("Layout", "v-3e486ff8").then(next)
    },
  },
  {
    path: "/index.html",
    redirect: "/"
  },
  {
    path: '*',
    component: GlobalLayout
  }
]